import { useTheme } from "@/src/styles/theme-provider";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Image, Platform, Pressable, Text, View } from "react-native";

type WikiCategoryCardProps = Readonly<{
  id: string;
  name: string;
  articleCount: number;
  onPress: (id: string) => void;
}>;

export default function WikiCategoryCard({
  id,
  name,
  articleCount,
  onPress,
}: WikiCategoryCardProps) {
  const { t } = useTranslation();
  const isWeb = Platform.OS === "web";
  const { themeVars } = useTheme();
  const [isCardHovered, setIsCardHovered] = useState(false);
  const [isCardPressed, setIsCardPressed] = useState(false);
  const isHighlighted = isWeb ? isCardHovered : isCardPressed;

  return (
    <Pressable
      onPress={() => onPress(id)}
      onHoverIn={() => setIsCardHovered(true)}
      onHoverOut={() => setIsCardHovered(false)}
      onPressIn={() => !isWeb && setIsCardPressed(true)}
      onPressOut={() => !isWeb && setIsCardPressed(false)}
      style={{
        borderColor: isHighlighted
          ? (themeVars["--color-primary-default"] as string)
          : (themeVars["--color-ash-3"] as string),
      }}
      className="flex-row px-2 bg-primary-2 rounded-2xl items-center border hover:bg-ash-3"
    >
      <View className="justify-center items-center">
        <View className="p-2.5 md:p-3 border-yellow-100 rounded-full bg-yellow-100">
          <Image
            resizeMode="cover"
            style={{ width: 24, height: 24 }}
            source={require("@/src/assets/images/wiki-folder.png")}
          />
        </View>
      </View>

      <View className="flex-col gap-2 p-4 flex-1">
        <Text className="text-onyx text-base font-medium" numberOfLines={1}>
          {name}
        </Text>
        <Text className="text-onyx text-sm">
          {`${articleCount} ${t("LABEL_ARTICLES")}`}
        </Text>
      </View>
    </Pressable>
  );
}
